// split-test vertical_grid_infinite_scroll

import EzController from 'controllers/ez-base-controller';
import { triggerCustomEvent, splitTestEnabled, truncateThumbnailTitles } from 'lib/helpers'; // split-test: resource_show_modal_view
import { getAjaxModal } from 'lib/ajax-helpers'; // split-test: resource_show_modal_view
import events from 'lib/events'; // split-test: resource_show_modal_view
import VerticalGrid from 'lib/vertical-grid';

require('intersection-observer');

export default class ResourcesVerticalGridController extends EzController {
  isResizing = false;

  verticalGrid = new VerticalGrid({
    containerClass: '.vertical-grid',
    itemClass: '.ez-resource-grid__item',
    widthAttribute: 'w',
    heightAttribute: 'h',
    columns: 5,
    horizontalGutter: 20,
    verticalGutter: 20,
    equalizeColumnHeights: true,
    listenForResize: false,
  });

  connect() {
    this.initGrid();

    window.addEventListener('InitAllGrids', this.initGrid);
    window.addEventListener('TruncateGridTitles', this.truncateTitles);
    window.addEventListener('InitVerticalGrids', this.initGrid);
    window.addEventListener('StartResultsInfiniteScroll', this.startInfiniteScroll);
    window.addEventListener('resize', this.initGrid);
  }

  disconnect() {
    window.removeEventListener('InitAllGrids', this.initGrid);
    window.removeEventListener('TruncateGridTitles', this.truncateTitles);
    window.removeEventListener('InitVerticalGrids', this.initGrid);
    window.removeEventListener('StartResultsInfiniteScroll', this.startInfiniteScroll);
    window.removeEventListener('resize', this.initGrid);
  }

  truncateTitles = () => {
    truncateThumbnailTitles(this.element);
  }

  initGrid = () => {
    this.isResizing = true;

    let cols = Math.floor(this.element.offsetWidth / 240);
    if (cols < 2) cols = 2;

    this.verticalGrid.updateConfig({
      columns: cols,
    });

    if (this.isResizing) this.verticalGrid.makeAllGrids();
    this.element.classList.remove('is-hidden');

    setInterval(() => {
      this.isResizing = false;
    }, 100);

    if (this.data.get('lazy') === 'true') {
      this.loadLazy(this.element.getAttribute('data-lazy-offset'));
    }
  }

  // start split-test: resource_show_modal_view
  // can remove check for split test and else path
  // if split test wins
  loadShowPage = (event) => {
    if (splitTestEnabled('show-page-modal-view')) {
      event.preventDefault();

      const resourceShowUrl = event.currentTarget.getAttribute('href');

      getAjaxModal(resourceShowUrl);

      triggerCustomEvent(events.show_page.modal.build_resource_navigation_context, {
        targetResourcePath: resourceShowUrl,
        targetResourceGroup: event.currentTarget.closest('[data-controller="resources-grid"]'),
      });
    }
  }
  // end split-test: resource_show_modal_view

  startInfiniteScroll = () => {
    this.element.dataset.truncateResults = false;
  }

  loadLazy(lazyLoadOffset) {
    const lazyImages = [].slice.call(this.element.querySelectorAll('.ez-resource-thumb__img[src^="data:"]'));

    if ('IntersectionObserver' in window) {
      const lazyImageObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const lazyImage = entry.target;
            lazyImage.onload = this.onLazyLoad;
            lazyImage.src = lazyImage.dataset.lazySrc;
            lazyImage.srcset = lazyImage.dataset.lazySrcset;
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      }, { rootMargin: `0px 0px ${lazyLoadOffset}px 0px` });

      lazyImages.forEach((lazyImage) => {
        lazyImageObserver.observe(lazyImage);
      });
    } else { // We should not get here as we use polyfill
      console.error('Intersection observer not supported'); // eslint-disable-line no-console
    }
  }

  onLazyLoad = (event) => {
    const image = event.target;
    const gridItem = image.closest('.ez-resource-grid__item');
    gridItem.classList.add('is-loaded');
  }
}
